export default "__VITE_ASSET__CvFQLgY9__"